import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';

export const ConfirmActionDialog = ({ open, title, rows = [], warning, confirmLabel, onCancel, onConfirm, testId }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
    <DialogContent className="bg-slate-900 border-amber-500/40 text-white" data-testid={testId}>
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-amber-300"><AlertTriangle className="w-5 h-5" /> {title}</DialogTitle>
        <DialogDescription className="text-slate-400">Real funds on Ethereum Mainnet. This can't be undone.</DialogDescription>
      </DialogHeader>
      <div className="rounded-lg border border-slate-700 bg-slate-800/60 p-4 space-y-2 text-sm">
        {rows.map(([k, v]) => (
          <div key={k} className="flex justify-between gap-4"><span className="text-slate-400">{k}</span><span className="text-white text-right">{v}</span></div>
        ))}
      </div>
      {warning && <p className="text-xs text-amber-300">{warning}</p>}
      <DialogFooter>
        <button onClick={onCancel} data-testid={`${testId}-cancel-btn`} className="px-4 py-2 text-sm text-slate-300 hover:text-white">Cancel</button>
        <button onClick={onConfirm} data-testid={`${testId}-confirm-btn`} className="px-4 py-2 text-sm rounded-md bg-amber-500 hover:bg-amber-600 text-white font-medium">{confirmLabel}</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ConfirmActionDialog;
